pageId = 'page-todolists'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.sortTodos()
  tower.sortTodolists()
  tower.adjustTodo()
  tower.adjustTodolist()
